var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUiManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.504761 7.06616C0.504761 6.51388 0.952476 6.06616 1.50476 6.06616H6.44749C6.70867 6.06616 6.95949 6.16835 7.14631 6.35086L9.25887 8.41476C9.44569 8.59728 9.69651 8.69946 9.95769 8.69946H17.0933C17.6456 8.69946 18.0933 9.14718 18.0933 9.69946V18.5341C18.0933 19.0864 17.6456 19.5341 17.0933 19.5341H1.50476C0.952478 19.5341 0.504761 19.0864 0.504761 18.5341V7.06616Z",
    stroke: "#0D0D0D",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3875 2.17717C11.4787 1.06307 11.7437 1.65714 11.1327 0.517659C10.4588 0.893762 9.37907 2.20754 9.51469 3.16788C9.65033 4.12819 10.1702 4.58145 10.9217 4.62499C11.2303 4.69522 12.1041 4.6352 12.5027 3.73188C12.8534 2.93719 12.4888 2.37421 12.3875 2.17717Z",
    stroke: "#0D0D0D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.976 4.60143C12.0131 5.24817 11.9865 7.24943 11.976 8.15231",
    stroke: "#0D0D0D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69512 7.8519C9.7266 7.13164 10.0364 5.40633 10.1299 4.59463",
    stroke: "#0D0D0D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4688 4.13503C19.3507 2.4375 19.2013 3.19273 19.3884 1.67396C18.4802 1.57758 16.5393 2.1107 16.0149 3.13178C15.4905 4.15286 15.6837 4.946 16.3806 5.5011C16.631 5.77969 17.5168 6.31811 18.5188 5.71686C19.4004 5.18792 19.4322 4.39469 19.4688 4.13503Z",
    stroke: "#0D0D0D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4159 6.19801C16.955 7.05113 16.509 7.83164 15.8611 8.5246",
    stroke: "#0D0D0D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.563 8.5257C13.3155 7.43698 14.5559 6.12699 15.6762 4.87364",
    stroke: "#0D0D0D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUiManager);
export default __webpack_public_path__ + "static/media/icon-ui-manager.1cee543200f918c0f475ef719c53e153.svg";
export { ForwardRef as ReactComponent };